module.exports = __webpack_public_path__ + "static/img/eicad_item3.bf0d849f.png";